import React, { Component } from 'react';
import { connect } from 'react-redux';
import { importPOVapeTemplate } from 'actions/EntityActions';
import ConfirmPODialog from './ConfirmPODialog';
import DialogInput from '../advanced/DialogInput';
import CustomButton from './Button';
import moment from 'moment';
import { Button } from '@mui/material';
import { showError } from 'actions/CommonActions';
import { readExcel } from 'utils/helpers';
import DialogHeaderWithClose from './DialogHeaderWithClose';

class ExcelUploadVapePO extends Component {
    constructor(props) {
        super(props);

        this.state = {
            openDialog: false,
            confirmDialog: false,
            totalPriceMatch: false,
            POName: '',
            model: {}
        };
    }

    callback = (model) => {
        let subtotal = 0;
        model.Products.map(item => { subtotal += item.Quantity * item.UnitPrice; });
        const today = new Date();
        this.props.purchaseOrderList.map(item => {
            if (item.subTotal != 0 && item.subTotal - subtotal < 0.2 && item.subTotal - subtotal > -0.2 && moment(today).diff(moment(item.creationDate), 'days') < 4)
                this.setState({
                    totalPriceMatch: true,
                    POName: item.description
                })
        });
        this.setState({ model: model });

        let thccbdinPO = false;
        for (let j = 0; j < model.Products.length; j++) {
            if (model.Products[j].thc > 0 || model.Products[j].cbd > 0) {
                thccbdinPO = true;
                break;
            }
        }
        if (!this.props.receivePurchaseOrderWhenCreate && thccbdinPO) {
            this.setState({ openDialog: true })
        }
        else {
            this.setState({ confirmDialog: true })
        }
    }

    uploadFile = (e, callback) => {
        e.preventDefault();
        let BranchId = this.props.branchId;
        let that = this;
        readExcel(e.target.files[0]).then((data) => {
            try {
                let productArray = [];
                if (data.length > 0) {
                    if (data[0]["SKU"] != "TECHPOS PO IMPORT Vape TEMPLATE") {
                        that.props.showError("Wrong template used! Please download the latest version of template and try again!");
                        return;
                    }

                    //shipping fee
                    let ShippingCost = data[4]["TotalQuantity"] ? Number(data[4]["TotalQuantity"].toString().replace('$', '')) : 0;
                    //vendor name
                    let VendorName = data[5]["TotalQuantity"];

                    if ((VendorName === "" || VendorName == undefined || VendorName == null)) {
                        this.props.showError("VendorName can't be empty!");
                        return;
                    }

                    //invoice name
                    let InvoiceName = data[6]["TotalQuantity"];
                    //pst
                    let PST = data[7]["TotalQuantity"] ? Number(data[7]["TotalQuantity"].toString().replace('$', '')) : 0;
                    //gst
                    let GST = data[8]["TotalQuantity"] ? Number(data[8]["TotalQuantity"].toString().replace('$', '')) : 0;
                    //hst
                    let HST = data[9]["TotalQuantity"] ? Number(data[9]["TotalQuantity"].toString().replace('$', '')) : 0;

                    for (let i = 11; i < data.length; i++) {
                        let item = data[i];
                        let SKU = item["SKU"];
                        let ProductName = item["ProductName(Optional)"];
                        let quantity = item["TotalQuantity"];
                        let unitCostPrice = item["UnitCostPrice"] ? item["UnitCostPrice"].toString().replace('$', '') : '';
                        let SalesPrice = item["UnitSalesPrice(Optional)"] ? item["UnitSalesPrice(Optional)"].toString().replace('$', '') : '';
                        let UPC = item["UPC(Optional)"];
                        let Variant = item["Variants(Salted, Ice, Pods..)"];
                        let CategoryName = item["CategoryName(Optional)"];
                        let Brand = item["BrandName(Optional)"];
                        let weight = item["Weight(Optional)"];

                        if ((SKU === "" || SKU == undefined || SKU == null) && (ProductName === "" || ProductName == undefined || ProductName == null)) {
                            that.props.showError("SKU or Product Name can't be empty! Please check line " + (i + 5));
                            return;
                        }

                        if (SKU.length >= 50) {
                            that.props.showError("SKU length can't be over 50 characters! Please check line " + (i + 5));
                            return;
                        }

                        if ((isNaN(quantity) || Number(quantity) <= 0) || (isNaN(unitCostPrice) || Number(unitCostPrice) <= 0)) {
                            that.props.showError(`Format issue detected for SKU:${SKU}. Please make sure no comma exists and trim all the cells in the file imported.`);
                            return;
                        }

                        let model = {
                            SKU,
                            Quantity: Number(quantity),
                            UnitPrice: Number(unitCostPrice),
                            SalesPrice: SalesPrice === "" ? null : Number(SalesPrice),
                            UPC,
                            ProductName,
                            CategoryName,
                            Variant,
                            Weight: weight === "" ? null : Number(weight),
                            Brand
                        };

                        productArray.push(model);
                    }

                    let model = {
                        BranchId,
                        VendorName,
                        ShippingCost,
                        PST,
                        GST,
                        HST,
                        InvoiceName,
                        Products: productArray
                    }
                    callback(model);
                } else {
                    this.props.showError("No data found in PO file, please make sure you upload the PO file with excel format.");
                    return;
                }
            } catch (error) {
                console.log(error);
                this.props.showError("PO Import fail, please do a hard refresh, check and remove the extra line in the file then try importing again.");
                return;
            }
        });
    }

    closeCheckDialog = () => {
        this.setState({ openDialog: false });
    }

    openConfirmDialog = () => {
        this.closeCheckDialog();
        this.setState({ confirmDialog: true });
    }

    closeConfirmDialog = () => {
        this.setState({ confirmDialog: false });
        this.setState({ totalPriceMatch: false, POName: "", model: [] });
    }

    createPO = () => {
        this.props.importPOVapeTemplate(this.state.model);
        this.closeConfirmDialog();
    }

    render() {
        const styles = {
            uploadButton: this.props.buttonStyles,
            uploadInput: {
                cursor: 'pointer',
                position: 'absolute',
                top: 0,
                bottom: 0,
                right: '2px',
                left: 0,
                width: '100%',
                opacity: 0
            }
        };
        return (
            <React.Fragment>
                <Button
                    sx={{ ...styles.uploadButton }}
                    variant="contained"
                    className="btnNewBrandPOS"
                >
                    <label>Import FROM VAPE TEMPLATE</label>
                    <input className="fileInput"
                        type="file"
                        style={styles.uploadInput}
                        id="importFromVapeTemplate"
                        onChange={(e) => this.uploadFile(e, this.callback)}
                        onClick={(e) => e.target.value = null} />
                    <DialogInput
                        title={<DialogHeaderWithClose text="Proceed With Purchase Order Create" classicClass="posDialogClassic" handleClose={() => this.closeCheckDialog()} />}
                        actions={[
                            <CustomButton
                                key={1}
                                type="CancelButton"
                                name="buttonCancel"
                                className="btn-space"
                                label="Cancel"
                                onTouchTap={() => this.closeCheckDialog()} />,
                            <CustomButton
                                key={2}
                                name="ConfirmButton"
                                label="Proceed"
                                primary={true}
                                onTouchTap={() => this.openConfirmDialog()} />]}
                        modal={true}
                        open={this.state.openDialog}>
                        <h3>Purchase Order Auto Receive is set to off</h3>
                        <h4>THC/CBD Levels in PO Template will not be recorded, Do you want to proceed?</h4>
                    </DialogInput>
                    <ConfirmPODialog
                        branchName={this.props.branchName}
                        totalPriceMatch={this.state.totalPriceMatch}
                        POName={this.state.POName}
                        model={this.state.model}
                        confirmDialog={this.state.confirmDialog}
                        closeDialog={this.closeConfirmDialog}
                        createPO={this.createPO} />
                </Button>
            </React.Fragment>
        );
    }
}

function mapStatetoProps(state) {
    return {
        branchId: state.common.branchId,
        province: state.common.store.provinceState,
        receivePurchaseOrderWhenCreate: state.common.applicationSettings.receivePurchaseOrderWhenCreate,
        branchName: state.common.store.name || '',
        purchaseOrderList: state.entity.purchaseOrderList || []
    };
}

function mapDispatchToProps(dispatch) {
    return {
        importPOVapeTemplate: (model) => dispatch(importPOVapeTemplate(model)),
        showError: (message) => dispatch(showError(message))
    }
}

export default connect(mapStatetoProps, mapDispatchToProps)(ExcelUploadVapePO);